module.exports = __webpack_public_path__ + "static/media/Gen-2 Runway ML.76b7fd3d.gif";